import { useTranslation } from 'react-i18next'

import CheckCircleIcon from '@/assets/icons/check-circle.svg?react'
import Stepper from '@/components/Stepper/Stepper'

import styles from './FormStepper.module.scss'

type Step = {
  label: string
}

type FormStepperProps = {
  steps: Step[]
  currentStep: number
}

const FormStepper = ({ steps, currentStep }: FormStepperProps) => {
  const { t } = useTranslation('common')

  const isCompleted = (index: number) => index < currentStep

  return (
    <Stepper aria-label={t('help.form-progress')}>
      {steps.map((step, index) => (
        <Stepper.Step
          key={step.label}
          label={step.label}
          icon={
            isCompleted(index) ? (
              <CheckCircleIcon className={styles.icon} aria-hidden="true" />
            ) : null
          }
          number={index + 1}
          disabled={index > currentStep}
          aria-current={index === currentStep ? 'step' : undefined}
          aria-label={t('help.form-step', {
            step: index + 1,
            total: steps.length,
            label: step.label
          })}
        />
      ))}
    </Stepper>
  )
}

export default FormStepper
